var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChartWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 18.958H2.5C2.15833 18.958 1.875 18.6747 1.875 18.333C1.875 17.9913 2.15833 17.708 2.5 17.708H17.5C17.8417 17.708 18.125 17.9913 18.125 18.333C18.125 18.6747 17.8417 18.958 17.5 18.958Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 6.9834H3.33333C2.875 6.9834 2.5 7.3584 2.5 7.81673V15.0001C2.5 15.4584 2.875 15.8334 3.33333 15.8334H4.66667C5.125 15.8334 5.5 15.4584 5.5 15.0001V7.81673C5.5 7.35007 5.125 6.9834 4.66667 6.9834Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 4.3252H9.33333C8.875 4.3252 8.5 4.7002 8.5 5.15853V15.0002C8.5 15.4585 8.875 15.8335 9.33333 15.8335H10.6667C11.125 15.8335 11.5 15.4585 11.5 15.0002V5.15853C11.5 4.7002 11.125 4.3252 10.6667 4.3252Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 1.66699H15.3333C14.875 1.66699 14.5 2.04199 14.5 2.50033V15.0003C14.5 15.4587 14.875 15.8337 15.3333 15.8337H16.6667C17.125 15.8337 17.5 15.4587 17.5 15.0003V2.50033C17.5 2.04199 17.125 1.66699 16.6667 1.66699Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChartWhite);
export default __webpack_public_path__ + "static/media/icon_chart_white.525b7e16abc5ad93b1fff91a8f1fda2f.svg";
export { ForwardRef as ReactComponent };